<script setup>
import { Inertia } from '@inertiajs/inertia';
import { PlusIcon } from "@heroicons/vue/outline"
import { ref, reactive, computed } from 'vue'
import { viewInvoiceInXero } from '@/Mixins/RoutesUserToXero'
import List from '@/Components/Models/Invoice/List.vue';
import InvoiceListActions from '@/Components/Models/Invoice/ListActions.vue'
import DueDateListItem from "@/Components/Models/Invoice/DueDateListItem.vue"

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	invoices: {
		type: Array,
		default: () => [],
	},
})

const emit = defineEmits([
    'item-clicked',
])

function itemClicked(event){
	emit('item-clicked', event.data)
}

const localInvoices = ref(props.invoices);
const hasFetchedInvoices = ref(!!localInvoices.value.length);

function invoicesLoaded(data){
	// merge the data into the localInvoices
	localInvoices.value = [...localInvoices.value, ...data];
	hasFetchedInvoices.value = true;
}

const columnDefs = reactive([
	{
		field: "organisation_name",
		minWidth: 200,
		headerName: "Organisation",
	},
	{ 
		field: "InvoiceNumber",
		minWidth: 180,
		headerName: "Inv #",
	},
	{ 
		field: "AmountPaid",
		minWidth: 120,
		headerName: "Paid",
		type: 'rightAligned',
	},
	{ 
		field: "AmountDue", 
		minWidth: 120,
		headerName: "Due",
		type: 'rightAligned',
	},
	{ 
		minWidth: 100,
		field: "DueDate",
		headerName: "Due Date",
		type: 'rightAligned',
		cellRenderer: DueDateListItem,
	},
	{
		field: "Status", 
		minWidth: 140,
		headerName: "Status",
	},
	{ 
		field: "actions", 
		minWidth: 200,
		cellRenderer: InvoiceListActions,
	}
])

</script>

<template>
    <SectionCard :full-width="true">

        <template #header>
			<div class="flex justify-between items-center">
				<span class="text-lg font-medium text-gray-900 mb-0">Invoices</span>
			</div>
        </template>
            
		<List
			:invoices="localInvoices"
			@invoices-loaded="invoicesLoaded"
			@item-clicked="itemClicked"
			:has-fetched-invoices="hasFetchedInvoices"
			:organisation="auth.active_organisation"
			:column-defs="columnDefs"
		/>

    </SectionCard>
</template>